import { Outlet } from "react-router-dom"
import { useAxiosAuth } from "../auth-view/api"
import AuthContextProvider from "./context/AuthContextProvider"

const AuthLayout = () => {

  return (
    <AuthContextProvider>
      <RunAxiosHook />
      <Outlet />
    </AuthContextProvider>
  )
}

export default AuthLayout

const RunAxiosHook = () => {
  useAxiosAuth()
  return <></>
}
